module.exports = __webpack_public_path__ + "img/youshi3.da91f24e.jpg";